__turbopack_context__.v({
  "root": "_9hOCya_root",
  "svg": "_9hOCya_svg",
});
